import React from "react";

export default function VirtualCareTag({ client }) {
  if (!client?.virtualCareTreatments?.length > 0 && !client.treatments)
    return null;

  if (
    client.treatments &&
    !client.treatments.filter((treatment) => treatment.virtualCareInfo.active)
      .length > 0
  )
    return null;

  return (
    <span
      style={{
        borderRadius: "50%",
        fontSize: "7px",
        color: "white",
        padding: "1px",
        backgroundColor: "#02B0FB",
        display: "inline-flex",
        fontWeight: "700",
      }}
    >
      VC
    </span>
  );
}
